module.exports = __webpack_public_path__ + "img/googlemybusiness-instruction-2.ce3e6e65.png";